import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import { FadeUp, SectionLabel } from "@/components/Reveal";
import { useContent } from "@/lib/api";

const PAGES = {
  privacy: {
    label: "Privacy Policy",
    title: "Privacy Policy",
    body: [
      ["Titolare del trattamento", "Martina Serra — Training & Coaching. Per qualsiasi richiesta relativa alla privacy puoi scrivere a serramartinacoaching@gmail.com."],
      ["Dati raccolti", "Attraverso il sito vengono raccolti: dati di contatto inviati tramite il modulo (nome, email, messaggio), dati di acquisto gestiti dal provider di pagamento (Stripe) e dati di navigazione tecnici."],
      ["Finalità", "I dati sono utilizzati esclusivamente per rispondere alle richieste, erogare i servizi acquistati (coaching online e schede di allenamento personalizzate), inviare comunicazioni relative agli ordini e adempiere agli obblighi fiscali e contabili."],
      ["Base giuridica e conservazione", "Il trattamento si basa sull'esecuzione del contratto e sul consenso. I dati sono conservati per il tempo necessario alle finalità indicate e secondo i termini di legge."],
      ["Diritti dell'interessato", "Puoi richiedere in qualsiasi momento accesso, rettifica, cancellazione o limitazione del trattamento dei tuoi dati scrivendo a serramartinacoaching@gmail.com."],
    ],
  },
  cookie: {
    label: "Cookie Policy",
    title: "Cookie Policy",
    body: [
      ["Cosa sono i cookie", "I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo dell'utente per migliorare l'esperienza di navigazione."],
      ["Cookie utilizzati da questo sito", "Questo sito utilizza esclusivamente cookie tecnici, necessari al funzionamento del sito e dei servizi di pagamento. Non vengono utilizzati cookie di profilazione di terze parti."],
      ["Gestione delle preferenze", "Puoi gestire o eliminare i cookie attraverso le impostazioni del tuo browser. La disabilitazione dei cookie tecnici può compromettere alcune funzionalità del sito."],
    ],
  },
  termini: {
    label: "Termini e condizioni",
    title: "Termini e condizioni",
    body: [
      ["Oggetto", "I presenti termini regolano l'acquisto di servizi di coaching online e schede di allenamento personalizzate tramite il sito di Martina Serra — Training & Coaching."],
      ["Servizi di coaching", "I pacchetti di coaching e le schede di allenamento sono servizi personalizzati. Dopo l'acquisto, il cliente riceve via email le istruzioni per iniziare il percorso, a partire dal questionario di valutazione iniziale."],
      ["Pagamenti", "I pagamenti sono elaborati in modo sicuro tramite Stripe. I prezzi sono indicati in euro e sono da intendersi al lordo di ogni onere: l'attività è svolta in regime forfettario ai sensi della L. 190/2014, pertanto le operazioni sono fuori campo IVA e non viene applicata l'imposta sul valore aggiunto."],
      ["Diritto di recesso", "Per i servizi di coaching non ancora avviati è possibile richiedere il rimborso entro 14 giorni dall'acquisto. Una volta iniziato il percorso (valutazione compilata o scheda consegnata), il servizio si intende avviato e il rimborso non è più dovuto, salvo diverso accordo."],
      ["Disclaimer", "I programmi di allenamento non sostituiscono il parere medico. Prima di iniziare qualsiasi percorso di allenamento è consigliabile consultare il proprio medico."],
    ],
  },
};

export default function Legal({ page }) {
  const content = useContent();
  const data = PAGES[page] || PAGES.privacy;
  return (
    <div data-testid={`legal-${page}-page`}>
      <Nav />
      <section className="mx-auto max-w-4xl px-6 pb-28 pt-40 lg:pt-52">
        <SectionLabel>{data.label}</SectionLabel>
        <FadeUp as="h1" delay={0.1} className="mt-6 font-display text-4xl text-ivory md:text-6xl">{data.title}</FadeUp>
        <div className="mt-16 flex flex-col gap-12">
          {data.body.map(([h, p], i) => (
            <FadeUp key={h} delay={i * 0.05}>
              <h2 className="font-display text-2xl text-ivory">{h}</h2>
              <p className="mt-4 text-sm leading-loose text-mute">{p}</p>
            </FadeUp>
          ))}
        </div>
        <p className="mt-16 border-t border-line pt-8 text-xs text-mute">Ultimo aggiornamento: luglio 2026</p>
      </section>
      <Footer content={content} />
    </div>
  );
}
